<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const reloadPage = () => {
  window.location.reload()
}
</script>

<template>
  <div class="flex min-h-screen items-center justify-center">
    <div class="text-center">
      <h1 class="mb-4 text-8xl font-bold text-gray-800">
        {{ 500 }}
      </h1>
      <p class="text-gray-600">{{ t('errorServer.title') }}</p>
      <i18n-t keypath="errorServer.message" tag="p" class="mb-4 text-gray-600">
        <template #email>
          <a href="mailto:aird@almaiura.it" class="underline"> aird@almaiura.it </a>
        </template>
      </i18n-t>
      <Button :label="t('errorServer.button')" @click="reloadPage" />
    </div>
  </div>
  <img src="/logo-fallen.png" alt="logo fallen" class="absolute bottom-5 left-5 h-60" />
</template>
